import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface SetupStatus {
	needsAdmin: boolean;
	needsCluster: boolean;
	needsRender: boolean;
	/** The wizard's completion marker (Cluster.setupCompletedAt is set). The
	 * app gates the first-run takeover on this so the TLS render mid-flow
	 * doesn't bounce the operator out before "Review & launch". */
	setupComplete: boolean;
	tlsMode: string;
	version: string;
}

export const SETUP_STATUS_KEY = ["setup-status"] as const;

/**
 * Public first-run signal the SPA gates on. Cheap + unauthenticated so the
 * login screen and the wizard can both read it before a session exists.
 */
export function useSetupStatus() {
	return useQuery({
		queryKey: SETUP_STATUS_KEY,
		queryFn: async (): Promise<SetupStatus | null> => {
			const { data } = await api.api.system["setup-status"].get();
			if (!data || data.success !== true) return null;
			return {
				needsAdmin: data.needsAdmin,
				needsCluster: data.needsCluster,
				needsRender: data.needsRender,
				setupComplete: data.setupComplete === true,
				tlsMode: data.tlsMode,
				version: data.version,
			};
		},
		retry: false,
		staleTime: 5_000,
	});
}
